/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './instant_deposits';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "ledger": {
        "nested": {
          "service": {
            "nested": {
              "GetInstantDepositSettlementDetailRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetInstantDepositSettlementDetailResponse": {
                "fields": {
                  "accountDetails": {
                    "type": ".squareup.ledger.service.GetInstantDepositAccountResponse",
                    "id": 1,
                    "rule": "optional"
                  },
                  "eligibilityDetails": {
                    "type": ".squareup.ledger.service.EligibleForInstantDepositResponse",
                    "id": 2,
                    "rule": "optional"
                  },
                  "eligibilityStatusLocalizedTitle": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "eligibilityStatusLocalizedDescription": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.GetInstantDepositSettlementDetailRequest && !$root.nested?.squareup?.nested?.ledger?.nested?.service?.nested?.GetInstantDepositSettlementDetailResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetInstantDepositSettlementDetailRequest @ squareup/instant-deposit/dashboard_service.proto at 12:1
 */
export const GetInstantDepositSettlementDetailRequest = $root.lookupType('squareup.ledger.service.GetInstantDepositSettlementDetailRequest');
fixType(GetInstantDepositSettlementDetailRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetInstantDepositSettlementDetailRequest);
/**
 * SOURCE GetInstantDepositSettlementDetailResponse @ squareup/instant-deposit/dashboard_service.proto at 17:1
 */
export const GetInstantDepositSettlementDetailResponse = $root.lookupType('squareup.ledger.service.GetInstantDepositSettlementDetailResponse');
fixType(GetInstantDepositSettlementDetailResponse, {
  accountDetails: {
    required: true
  },
  eligibilityDetails: {
    required: true
  }
});
Builder.createAndAttachToType(GetInstantDepositSettlementDetailResponse);